import * as React from 'react';

export const MainContent: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div>{children}</div>;
};
